import ono from "@jsdevtools/ono";
export * from "@jsdevtools/ono";
export default ono;
